import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import usePaginator from "../../../../theme/Component/usePaginator";
import { _ProductionPlanItem } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable, MASK_DECIMAL } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { InputDate } from "../../../../theme/Input/InputDate";
import { InputMoney } from "../../../../theme/Input/InputMoney";


interface Props {
    idProductionPlan: number;
    productionPlanDate: any;
}

export const PlanItemCatalog = ({ idProductionPlan, productionPlanDate }: Props) => {

    const itemcatalog = useDataBean(_ProductionPlanItem);

    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProductionPlan, productionPlanDate])

    const getLista = () => {

        itemcatalog.instance.getProductionPlanItemCatalog(idProductionPlan, productionPlanDate, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }


    const deleteItem = () => {
        itemcatalog.deleteItemVoid(itemcatalog.bean.IDIncapacityWelfarePayment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const create = () => {
        itemcatalog.setBean({

        });
        console.log(itemcatalog.bean)
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        if (!itemcatalog.bean.ProductionItemDate) {
            toast.warning("Debe seleccionar una Fecha Planeada de Producción.");
            return;
        }


        itemcatalog.instance.addProductionPlanItem(idProductionPlan, productionPlanDate, itemcatalog.bean.ProductionItemDate, itemcatalog.bean.PlannedQuantity, itemcatalog.bean.RealQuantity, itemcatalog.bean.Observations).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDProductionPlanItem', visible: true },
        { title: 'Fecha Planeada de Producción', property: 'ProductionItemDate', visible: true },
        { title: 'Cantidad Planeada', property: 'PlannedQuantity', visible: true, mask: MASK_DECIMAL },
        { title: 'Cantidad Real', property: 'RealQuantity', visible: true, mask: MASK_DECIMAL },
        { title: 'Observaciones', property: 'Observations', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicPage titulo="Consultar Pagos Realizados por la Entidad">
                    <BasicTable body={lista} head={head} rowSet={itemcatalog.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate label="Fecha Planeada de Producción" name="ProductionItemDate" value={itemcatalog.bean.ProductionItemDate} setDate={(e: any) => { itemcatalog.setBean({ ...itemcatalog.bean, 'ProductionItemDate': e }) }} ></InputDate>
                            </div>
                            {/* <div className="col-md-6">
                                <InputMoney _label="Cantidad Planeada" _value={itemcatalog.bean.PlannedQuantity} onChange={(e) => { itemcatalog.setBean({ ...itemcatalog.bean, "PlannedQuantity": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputMoney _label="Cantidad Real" _value={itemcatalog.bean.RealQuantity} onChange={(e) => { itemcatalog.setBean({ ...itemcatalog.bean, "RealQuantity": e }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <label >Cantidad Planeada</label>
                                <input type='text' name='PlannedQuantity' className="form-control" value={itemcatalog.bean.PlannedQuantity} onChange={(e) => { itemcatalog.setBean({ ...itemcatalog.bean, "PlannedQuantity": parseInt(e.target.value) }) }} ></input>
                            </div>
                            <div className="col-md-6">
                                <label >Cantidad Real</label>
                                <input type='text' name='RealQuantity' className="form-control" value={itemcatalog.bean.RealQuantity} onChange={(e) => { itemcatalog.setBean({ ...itemcatalog.bean, "RealQuantity": parseInt(e.target.value) }) }} ></input>
                            </div>
                            <div className="col-md-12">
                                <label >Observaciones</label>
                                <textarea name='Observations' className="form-control" value={itemcatalog.bean.Observations} onChange={itemcatalog.handleChange} ></textarea>
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </BasicPage>

            </div>

        </div>
    )
}